import { create } from "zustand"

interface UIState {
  hideMobileNav: boolean
  setHideMobileNav: (hide: boolean) => void
  showEditProfileTipsModal: boolean
  setShowEditProfileTipsModal: (show: boolean) => void
}

export const useUIStore = create<UIState>(set => ({
  hideMobileNav: false,
  setHideMobileNav: hide => set({ hideMobileNav: hide }),
  showEditProfileTipsModal: false,
  setShowEditProfileTipsModal: show => set({ showEditProfileTipsModal: show }),
}))
